export default __webpack_public_path__ + "static/media/IDE-Command.dc4b4d05.png";